if (typeof Plugin_Dotace === 'undefined') {

    var Plugin_Dotace = {
        init: function () {
            var buttonUpdate = $('#button-update-grant-list');
            if(buttonUpdate.length) {
                buttonUpdate
                    .off('click')
                    .on('click', function(e){
                    e.preventDefault();
                    Plugin_Dotace.updateGrantList();
                });
            }

            var buttonCreate = $('#button-create-grant');
            if (buttonCreate.length) {
                buttonCreate
                    .off('click')
                    .on('click', function (e) {
                        e.preventDefault();
                        Plugin_Dotace.createGrant();
                    });
            }
        },

        createGrant: function() {

            var section = $('#idSection');
            if (!section.length || 102 !== parseInt(section.val())) {
                return;
            }

            $(document)
                .on('modal.button.miniform.build', function () {
                    var panel = $('#modal-create-grant');
                    if (!panel.length) {
                        return;
                    }

                    var rokTitulu = $('#roktitulu');
                    if (!rokTitulu.length) {
                        return;
                    }

                    var nazevTitulu = $('#nazevtitulu');
                    if (!nazevTitulu.length || !nazevTitulu.val()) {
                        return;
                    }

                    var modalForm = $('#miniform');
                    if (!modalForm.length) {
                        return;
                    }

                    var nazevDotace = modalForm.find('#modal-nazevdotace');
                    if (!nazevDotace.length) {
                        return;
                    }

                    nazevDotace.val(rokTitulu.val() + ' ' + nazevTitulu.val());
                });

            $(document)
                .off('modal.button.miniform.close.pre')
                .on('modal.button.miniform.close.pre', function () {
                    var panel = $('#modal-create-grant');
                    if (!panel.length) {
                        return;
                    }

                    var modalForm = $('#miniform');
                    if (!modalForm.length) {
                        return;
                    }

                    var _ch = $('#_ch');
                    if(!_ch.length) {
                        return false;
                    }

                    var nazevDotace = modalForm.find('#modal-nazevdotace');
                    if (!nazevDotace.length || !nazevDotace.val()) {
                        return;
                    }

                    var url = window.location.protocol + '//' + window.location.host;
                    url += '/plugin/PluginDotace/ajaxCreateGrant';

                    var idSection = $('#idSection').val();
                    var idItem = $('#idItem').val();
                    if(idSection.length) {
                        url += '/' + idSection;
                        if(idItem.length) {
                            url += '/' + idItem;
                        }
                    }

                    $.ajax({
                        type: 'post',
                        url: url,
                        dataType: "json",
                        global: true,
                        data: {'_ch': _ch.val(), 'nazevDotace': nazevDotace.val()},
                        beforeSend: function () {
                            Lemo_Alert.closeAll();
                            Lemo_Alert.addInfo('Odesílám požadavek na založení Dotace ...', 'createGrantBeforeBeforeSend');
                        },
                        complete: function () {
                            Lemo_Alert.closeById('createGrantBeforeBeforeSend');
                        },
                        success: function (r) {
                            if (r.hasOwnProperty('messages')) {
                                Lemo_Alert.addMany(r.messages);
                            }
                        },
                        error: function () {
                            Lemo_Alert.addDanger('Odeslání požadavku na založení dotace selhalo ...', 'createGrantError');
                        }
                    });
                });
        },

        updateGrantList: function() {

            var url = window.location.protocol + '//' + window.location.host;
            url += '/plugin/PluginDotace/ajaxUpdateGrantList';

            $.ajax({
                type: 'post',
                url: url,
                dataType: "json",
                global: true,
                beforeSend: function () {
                    Lemo_Alert.addInfo('Aktualizuji číselník dotací ...', 'updateGrantList');
                },
                complete: function () {
                    Lemo_Alert.closeById('updateGrantList');
                },
                success: function (r) {
                    if (r.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(r.messages);
                    }
                },
                error: function () {
                    Lemo_Alert.addDanger('Aktualizace číselníku dotací selhala ...', 'errorUpdateGrantList');
                    return false;
                }
            });
        }
    }
}

$(document)
    .ready(function () {
        Plugin_Dotace.init();
    });
